import axios from "axios";
import axiosInstance from "../utils/axiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const submitApplication = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/application`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const updateApplication = async (applicationId, formData) => {
  try {
    const response = await axiosInstance.put(`${API_BASE_URL}/application/${applicationId}`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const submitCommunity = async (formData, formSource) => {
  try {
    let communityEndPoint = `${API_BASE_URL}/communities/create`;
    if (formSource !== "page") {
      communityEndPoint = `${API_BASE_URL}/communities/createbyAdmin`;
    }
    const response = await axiosInstance.post(communityEndPoint, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const submitBulkCommunity = async (formData) => {
  try {
    let communityEndPoint = `${API_BASE_URL}/communities/createBulkCommunities`;
    const response = await axiosInstance.post(communityEndPoint, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const editCommunity = async (formData) => {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/communities/${formData.id}`,
      formData
    ); // Adjust URL as needed
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const fetchApplications = async (page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get("/application/getAll", {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const fetchApplicationById = async (id, page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get(`/application/getByCommunity/${id}`, {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const fetchCommunities = async (page, pageSize, filter) => {
  try {
    const response = await axiosInstance.get("/communities", {
      params: { page, pageSize, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching communities:", error);
    throw error;
  }
};

export const fetchNearByCommunities = async () => {
  try {
    const response = await axiosInstance.get("/communities/nearby");
    return response.data;
  } catch (error) {
    console.error("Error fetching communities:", error);
    throw error;
  }
};

export const deleteCommunity = async (id) => {
  try {
    const response = await axiosInstance.delete(`/communities/${id}`);
    console.log("Community deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting community:", error);
    throw error;
  }
};

export const deleteApplication = async (id) => {
  try {
    const response = await axiosInstance.delete(`/application/${id}`);
    console.log("Application deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting Application:", error);
    throw error;
  }
};

export const downloadApplication = async (id) => {
  try {
    const response = await axiosInstance.get(`/application/${id}/pdf`, {
      responseType: 'blob',
    });
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(new Blob([response.data]));
    link.href = url;
    link.setAttribute('download', `application_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error deleting Application:", error);
    throw error;
  }
};

export const fetchInvoices = async (page, pageSize, filter) => {
  try {
    const response = await axiosInstance.get("/invoices", {
      params: { page, pageSize, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};

export const submitInvoice = async (formData) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/invoices/create`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const updateInvoiceStatus = async (invoiceId) => {
  try {
    const response = await axiosInstance.patch(`/invoices/update-status/${invoiceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};
